import { MutationTree } from 'vuex'
import { NotificationState } from './state'
import { NotificationMutationTypes } from './mutation-types'

export type Mutations<S = NotificationState> = {
  [NotificationMutationTypes.SET_UNREAD_COUNT](state: S, count: number): void
  [NotificationMutationTypes.INCREMENT_UNREAD_COUNT](state: S): void
}

export const mutations: MutationTree<NotificationState> & Mutations = {
  [NotificationMutationTypes.SET_UNREAD_COUNT](state: NotificationState, count: number) {
    state.unreadCount = count
  },
  [NotificationMutationTypes.INCREMENT_UNREAD_COUNT](state: NotificationState) {
    state.unreadCount++
  }
}